import { SIMPLMenuHeader } from "../../components/commons/header/SIMPLMenuHeader";
import { SIMPLTable } from "../../components/commons/table/SimplTable";
import { Layout } from "../../components/commons/layout/Layout";
import { LABELS } from "~/resources/Labels";
import { SIMPLTitle } from "../../components/commons/title/SIMPLTitle";
import { ChangeEvent, useEffect, useState } from "react";
import {
  PropRow,
  SortTable,
  TemplateResponse,
} from "~/models/Commons ";

import AddIcon from "@mui/icons-material/Add";
import { Entries } from "~/models/enums/Entries";
import {
  attachResourcesToCloudEnviroments,
  displayEntries,
  getDefaultQueryParams,
  handleTabChange,
  sortScripts,
} from "~/Utils/Utils";
import { SIMPLButtonCustomized } from "../../components/commons/button/SIMPLButtonCustumized";
import { SIMPLAlert } from "../../components/commons/dialog/SimplAlert";
import { MESSAGES } from "~/resources/Message";
import { toast } from "react-toastify";
import { PayloadType } from "~/models/types/Payload";
import useSessionTimeout from "~/services/session/SessionTimeOut";
import { useAppDispatch } from "~/hooks/appSelector";
import { AddVmTemplate } from "./AddVmTemplate";
import { VmTemplateHeader } from "~/models/vmtemplate/VmTemplate";
import { useDeleteVmTemplatesMutation, useGetVmTemplatesQuery } from "~/services/vm/VmTemplate";
import { useGetComponentsQuery } from "~/services/vm/Components";
import { LoadingWrapper } from "../../components/commons/spiner/SimpleLoaderWrapper";
import { DetailsVmTemplate } from "./DetailsVmTemplate";
import { EditVmTemplate } from "./EditVmTemplate";
import { DELETE_VMTEMPLATE_BYID } from "~/store/feature/VmTemplates";

export const SIMPLVmTemplate = () => {
  const dispatch = useAppDispatch();
  const [deleteVmTemplate] = useDeleteVmTemplatesMutation();
  const { data: ConfigurationComponentsData } = useGetComponentsQuery(
    getDefaultQueryParams("vmConfiguration")
  );

  const { data: ProvissioningComponentsData } = useGetComponentsQuery(
    getDefaultQueryParams("postProvisioning")
  );

  const { data: PolicyComponentsData } = useGetComponentsQuery(
    getDefaultQueryParams("policy")
  );
  const [active,setActive] = useState<boolean>(true);
  const [showFilter, setShowFilter] = useState<boolean>(false);
  const [viewModalVmTemplate, setViewModalVmTemplate] = useState(false);
  const [viewEditVmTemplate, setViewEditVmTemplate] = useState(false);
  const [rows, setRows] = useState([] as PropRow[]);
  const [size, setSize] = useState<number>(15);
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [page, setPage] = useState<number>(0);
  const [total, setTotal] = useState<number>(0);
  const [showPagination, setShowPagination] = useState(true);
  const [totalElements, setTotalElements] = useState<number>(0);
  const [item, setItem] = useState({} as TemplateResponse);
  const [deleteModal, setDeleteModal] = useState(false);
  const INACTIVITY_LIMIT = Number(import.meta.env.VITE_INACTIVITY_LIMIT);
  const FORCED_LOGOUT_LIMIT_EXPIRED_TOKEN = Number(
    import.meta.env.VITE_FORCED_LOGOUT_LIMIT_EXPIRED_TOKEN
  );
  const { data, refetch, isLoading, isFetching, isError } =
    useGetVmTemplatesQuery({
      page,
      size,
      active:false,
    });
  const [sortConfig, setSortConfig] = useState<SortTable>({
    key: "",
    direction: LABELS.ASC,
  });
  const handleSort = (key: string) => {
    const direction =
      sortConfig.key === key && sortConfig.direction === LABELS.ASC
        ? LABELS.Desc
        : LABELS.ASC;
    setSortConfig({ key, direction });
  };

  /**
   * Initializes session timeout handling.
   *
   * @param {Object} config - Configuration for session timeout.
   * @param {number} config.inactivityLimit - Time in ms before user is considered inactive.
   * @param {number} config.forcedLogoutLimit - Time in ms before forced logout after inactivity.
   * @param {Function} config.buildLogoutUrl - Function that returns the logout URL.
   * @param {Storage} config.storage - Storage mechanism (e.g., sessionStorage).
   * */
  useSessionTimeout({
    inactivityLimit: INACTIVITY_LIMIT,
    forcedLogoutLimit: FORCED_LOGOUT_LIMIT_EXPIRED_TOKEN,
    storage: sessionStorage,
  });

  /**
   * Initializes and sets the table rows by:
   * 1. Filtering scripts based on the active tab.
   * 2. Sorting the filtered scripts according to the sort configuration.
   * 3. Mapping sorted scripts to table row format and setting rows.
   */
  const initVmTemplate = () => {
    // Ensure payload exists before processing
    const payload = data?.payload as PayloadType | undefined;

    if (!payload || payload.length === 0) {
      setShowPagination(false);
      return;
    }
    // Attach resources, sort scripts, and customize entries
    const scriptMergedList = attachResourcesToCloudEnviroments(payload);
    const sortedScripts = sortScripts(scriptMergedList, sortConfig);
    const customizedList = displayEntries(
      sortedScripts,
      totalElements,
      Entries.Twenty
    );
    // Set pagination visibility and total elements count
    const totalPages = payload?.page?.totalPages ?? 0;
    setTotal(Number(totalPages));

    if (payload?.page?.totalElements) {
      setTotalElements(payload?.page?.totalElements);
    }
// Filter vm Template based on Active
const filteredTemplateList = (customizedList?.filter(env => env.active)) ?? [];
    // Process rows and set them
    const templateRows: PropRow[] = filteredTemplateList.map((templateItem: any) => ({
      row: templateItem,
    }));
    setRows(templateRows);
    setShowPagination(true);
  };

  useEffect(() => {
    initVmTemplate();
  }, [
    data,
    active,
    sortConfig,
    size,
    total,
    totalElements,
    ConfigurationComponentsData,
    ProvissioningComponentsData,
    PolicyComponentsData,
  ]);

  /**
   * @effect
   * - Runs when the 'active' dependency changes.
   * - Calls setPage(1) to reset the pagination.
   */
  useEffect(() => {
    setPage(0);
    handlePaginationSize();
  }, [active, size]);
  const handleCloseAddModal = () => setIsAddModalOpen(false);
  const handlePaginationSize = () => {
    if ([Entries.Ten, Entries.Twenty].includes(size)) {
      setPage(0);
    }
  };

  /* Renders "Cancel" and "Delete Item" buttons for alerts */
  const renderAlertButtons = () => (
    <>
      <div className="grow-0 basis-32 mr-5">
        <SIMPLButtonCustomized
          label="Cancel"
          secondary
          buttonHandlerAction={() => setDeleteModal(false)}
        />
      </div>
      <div className="grow-0 basis-32">
        <SIMPLButtonCustomized
          label="Delete Item"
          danger
          buttonHandlerAction={handleDeleteVmTemplate}
        />
      </div>
    </>
  );

  /*Renders delete alert with cancel and delete actions */
  const renderDeleteAlert = () =>
    deleteModal && (
      <SIMPLAlert
        onCancel={() => setDeleteModal(false)}
        message={MESSAGES.MessageDialogDelete(item.name)}
        title={LABELS.DeleteVmTemplate}
        actions={renderAlertButtons()}
      />
    );

  const handleConfirmDelete = (template: TemplateResponse) => {
    if (template.id) {
      setItem(template);
      setDeleteModal(true);
    } else {
      console.warn(LABELS.TemplateDoesNotExist);
    }
  };

  const handleDeleteVmTemplate = async () => {
    try {
      setDeleteModal(false);
      toast.loading(LABELS.DeletingVmTemplate);

       await deleteVmTemplate(item.id).unwrap();
      dispatch(DELETE_VMTEMPLATE_BYID(item.id));
      toast.dismiss();
      toast.success(MESSAGES.MessageTemplateRemoved);
    } catch (error:any) {
      toast.dismiss();
     const errorTitle = error?.data?.title ?? error?.title ?? "Unknown error";
      const errorStatus = error?.data?.status ?? error?.status ?? "N/A";

      toast.error(`Status: ${errorStatus}\nTitle: ${errorTitle}`);
      console.error("submitForm: error occurred", error);
    } finally {
      refetch();
    }
  };

  const showFilterHandler = () => setShowFilter((prev) => !prev);

  const handleSizeChange = (e: ChangeEvent<HTMLSelectElement>) => {
    setSize(Number(e.target.value));
  };
  const handleResetAll = () => {
    setPage(0);
    setShowFilter(false);
  };
  const handlePageChange = (page: number) => {
    setPage(page);
  };
  const handleEdit = (scriptItem: TemplateResponse) => {
      if (scriptItem.id) {
        setItem(scriptItem);
        setViewEditVmTemplate(true);
      } else {
        console.warn(LABELS.ScriptIdDonotExist);
      }
    };
 const renderEditView = () =>
    viewEditVmTemplate && (
      <EditVmTemplate
        onCloseModal={()=>setViewEditVmTemplate(false)}
        title='Update Vm Template '
        editedItem={item}
        setConfig={setSortConfig}
        refetch={refetch} />
    );

  /* Renders the "Add Script" button */
  const renderButtonAddProvider = () => (
    <SIMPLButtonCustomized
      label={LABELS.AddVmTemplate}
      buttonHandlerAction={() => setIsAddModalOpen(true)}
      firstIcon={<AddIcon fontSize="small" />}
      secondIcon={<AddIcon fontSize="small" />}
      secondary
    />
  );
  const renderAddVmTemplateModal = () =>
    isAddModalOpen && (
      <AddVmTemplate
        onCloseModal={handleCloseAddModal}
        editedItem={null}
        setConfig={setSortConfig}
        title={LABELS.VmTemplate}
        refetch={refetch}
      />
    );
  const handleOpenDetail = (scriptItem: TemplateResponse) => {
    setItem(scriptItem);
    setViewModalVmTemplate(true);
  };
  const renderDetailViewVmTemplate = () =>
    viewModalVmTemplate && (
      <DetailsVmTemplate
        onClose={() => setViewModalVmTemplate(false)}
        title={LABELS.DetailView}
        item={item}
      />
    );
  const renderSIMPLTable = () => (
    <div className="flex flex-col w-full">
      <div className="mt-5">
        <div className="container mx-auto mt-10">
          <SIMPLTable
            clear={handleResetAll}
            button={renderButtonAddProvider()}
            page={page}
            total={total}
            totalElements={totalElements}
            showPagination={showPagination}
            active={active}
            showHandler={showFilterHandler}
            filterActive={showFilter}
            tableHeaders={VmTemplateHeader}
            rows={rows}
            onChangePage={handlePageChange}
            onChange={handleSizeChange}
            handleOpenEdit={handleEdit}
            handleOpenDetail={handleOpenDetail}
            handleDelete={handleConfirmDelete}
            sortConfig={sortConfig}
            handleSort={handleSort}
            chipLabels={[]}
            custumizedNoDataAvailable={LABELS.NoTemplatesAvailable}
            showButtonDetails
            showEdit
            showButtonDelete
             handlerChips={() =>
                          handleTabChange(active, LABELS.Active, LABELS.Inactive, setActive)
                        }
          />
        </div>
      </div>
    </div>
  );
  const renderSIMPLTitle = () => (
    <SIMPLTitle title={LABELS.VMTemplateManagment} />
  );

  return (
    <SIMPLMenuHeader>
      <Layout>
        {renderEditView()}
        {renderSIMPLTitle()}
        {renderDeleteAlert()}
        {renderAddVmTemplateModal()}
        {renderDetailViewVmTemplate()}
        <LoadingWrapper
          loadingTitle="Loading VmTemplate..."
          isLoading={isLoading || isFetching}
          isError={isError}
        >
          {renderSIMPLTable()}
        </LoadingWrapper>
      </Layout>
    </SIMPLMenuHeader>
  );
};
